var _defs, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNowNycTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 219.28 983.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:201px;fill:none;stroke:#ff285b;stroke-width:2px;font-family:Archia-Bold, Archia;font-weight:700;letter-spacing:-0.01em;}.cls-2{letter-spacing:-0.07em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "title") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(47.43 1) rotate(90)"
  }, "NOW-N", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 707.51,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    x: 826.5,
    y: 0
  }, "C"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowNycTitle);
export default __webpack_public_path__ + "static/media/NowNycTitle.82c1df9d4eaae86c6b8bd3bebdaf0b31.svg";
export { ForwardRef as ReactComponent };